/* By Lilo — productpagina: galerij, variantkiezer (pills), verzend-countdown.
   Add-to-cart zelf loopt via Dawn's product-form.js (cart-drawer). */
(function () {
  function money(cents, format) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return (format || '€{{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, amount).replace('EUR', '').trim();
  }

  function initGallery(root) {
    var main = root.querySelector('.bl-gallery__main img');
    if (!main) return;
    root.querySelectorAll('.bl-gallery__thumbs button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.dataset.full;
        if (src) {
          main.src = src;
          if (btn.dataset.srcset) main.srcset = btn.dataset.srcset; else main.removeAttribute('srcset');
          if (btn.dataset.alt) main.alt = btn.dataset.alt;
        }
        root.querySelectorAll('.bl-gallery__thumbs button').forEach(function (b) { b.setAttribute('aria-current', b === btn ? 'true' : 'false'); });
      });
    });
  }

  function initVariants(root) {
    var dataEl = root.querySelector('[data-bl-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = root.querySelector('form[data-type="add-to-cart-form"] input[name="id"], product-form input[name="id"]');
    var priceEl = root.querySelector('[data-bl-price]');
    var compareEl = root.querySelector('[data-bl-compare]');
    var buyBtn = root.querySelector('.bl-buy-btn');
    var buyPrice = root.querySelector('[data-bl-buy-price]');
    var moneyFormat = dataEl.dataset.moneyFormat;
    var strings = {
      soldOut: dataEl.dataset.soldOut || 'Uitverkocht',
      addToCart: dataEl.dataset.addToCart || 'In winkelwagen',
      chooseSize: dataEl.dataset.chooseSize || 'Kies eerst je maat'
    };

    function missingRequired() {
      var missing = null;
      root.querySelectorAll('.bl-variants[data-bl-size-required]').forEach(function (group) {
        if (!missing && !group.querySelector('input:checked')) missing = group;
      });
      return missing;
    }

    // Capture-fase op de root: vangt ook de klik die de mobiele sticky-balk doorgeeft.
    root.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.bl-buy-btn');
      if (!btn) return;
      var group = missingRequired();
      if (!group) return;
      e.preventDefault();
      e.stopPropagation();
      group.classList.remove('bl-variants--attention');
      void group.offsetWidth;
      group.classList.add('bl-variants--attention');
      group.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, true);

    function currentSelection() {
      var opts = [];
      root.querySelectorAll('.bl-variants[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        opts[parseInt(group.dataset.optionIndex, 10)] = checked ? checked.value : null;
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function update() {
      var sel = currentSelection();
      var variant = findVariant(sel);
      root.querySelectorAll('.bl-variants').forEach(function (group) {
        var label = group.querySelector('.bl-variants__label em');
        var checked = group.querySelector('input:checked');
        if (label && checked) label.textContent = checked.value;
        if (checked) group.classList.remove('bl-variants--attention');
      });
      if (buyBtn && missingRequired()) {
        var waitSpan = buyBtn.querySelector('[data-bl-buy-label]');
        buyBtn.setAttribute('data-bl-needs-size', '');
        buyBtn.removeAttribute('disabled');
        if (waitSpan) waitSpan.textContent = strings.chooseSize;
        return;
      }
      if (buyBtn) buyBtn.removeAttribute('data-bl-needs-size');
      if (!variant) return;
      if (idInput) {
        idInput.value = variant.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (priceEl) priceEl.textContent = money(variant.price, moneyFormat);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = money(variant.compare_at_price, moneyFormat);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (buyPrice) buyPrice.textContent = money(variant.price, moneyFormat);
      if (buyBtn) {
        var span = buyBtn.querySelector('[data-bl-buy-label]');
        if (variant.available) {
          buyBtn.removeAttribute('disabled');
          if (span) span.textContent = strings.addToCart;
        } else {
          buyBtn.setAttribute('disabled', 'disabled');
          if (span) span.textContent = strings.soldOut;
        }
      }
      if (variant.featured_media && variant.featured_media.preview_image) {
        var main = root.querySelector('.bl-gallery__main img');
        if (main) { main.src = variant.featured_media.preview_image.src + '&width=1000'; main.removeAttribute('srcset'); }
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    root.querySelectorAll('.bl-variants input').forEach(function (input) {
      input.addEventListener('change', update);
    });
    update();
  }

  function initCountdown(root) {
    var el = root.querySelector('[data-bl-countdown]');
    if (!el) return;
    var cutoff = (el.dataset.cutoff || '23:59').split(':');
    var tpl = el.dataset.template || 'Bestel binnen {h} u {m} min — vandaag nog verzonden';
    // serveranker: verschil tussen shoptijd en kloktijd van de bezoeker
    var serverNow = parseInt(el.dataset.serverNow, 10) * 1000;
    var skew = isNaN(serverNow) ? 0 : serverNow - Date.now();
    function tick() {
      var now = new Date(Date.now() + skew);
      var target = new Date(now);
      target.setHours(parseInt(cutoff[0], 10), parseInt(cutoff[1], 10), 0, 0);
      var diff = target - now;
      if (diff <= 0) { el.closest('.bl-pdp__countdown').hidden = true; return; }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      el.textContent = tpl.replace('{h}', h).replace('{m}', m);
    }
    tick();
    setInterval(tick, 30000);
  }

  function boot() {
    document.querySelectorAll('.bl-pdp-root').forEach(function (root) {
      if (root.dataset.blInit) return;
      root.dataset.blInit = '1';
      initGallery(root);
      initVariants(root);
      initCountdown(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.bl-pdp-root').forEach(function (r) { delete r.dataset.blInit; });
    boot();
  });
})();
